export var EducationData = [{
    "session": "2005-2015",
    "subject": "Science",
    "institute": "Banglar Hat MUBL Dakhil Madrasha",
    "result": "GPA: 4.94 (Out of 5.00)"
  }, {
    "session": "2015-2019",
    "subject": "Computer Science & Technology",
    "institute": "Kurigram Polytechnic Institute",
    "result": "CGPA: 3.22 (Out of 4.00)"
  },{
    "session": "2020-2024",
    "subject": "B.Sc In CSE",
    "institute": "Dhaka International University",
    "result": "CGPA: 3.58 (Out of 4.00)"
  }];